<template>
  <PhoneVerificationError
    v-if="verificationResult.length"
    @resendSms="resendSms"
    @close="$emit('close')"
  />
  <PhoneVerificationFirstStep
    v-else-if="currentStep === 1"
    :countdown="countdown"
    @resendSms="resendSms"
    @close="$emit('close')"
    @next-click="$emit('next-click')"
    @prev-click="$emit('prev-click')"
  />
  <PhoneVerificationSecondStep v-else-if="currentStep === 2" @close="$emit('close')" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import userAppData from '@/mixins/userAppData';
import countdown from '@/mixins/countdown';
import phoneVerification from '@/mixins/phoneVerification';
import PhoneVerificationError from '@/components/Atoms/PhoneVerificationError';
import PhoneVerificationFirstStep from '@/components/Atoms/PhoneVerificationFirstStep';
import PhoneVerificationSecondStep from '@/components/Forms/PhoneVerificationSecondStep';

export default {
  name: 'PhoneVerification',
  components: { PhoneVerificationSecondStep, PhoneVerificationFirstStep, PhoneVerificationError },
  mixins: [userAppData, countdown, phoneVerification],
  computed: {
    currentStep() {
      const step = +this.$route.query.pv_step || 1;
      return step > 0 && step <= 2 ? step : 1;
    },
    ...mapGetters({
      dialog: 'profile/dashboard/dialog',
      verificationResult: 'profile/phoneVerification/verificationResult'
    })
  },
  watch: {
    async currentStep(newValue) {
      if (!this.$auth.user.verify.phone && newValue === 1) {
        await this.getUserAppData();
        this.$eventHub.$emit('setPhoneCountdown', this.resendSMSTimeDefaultValue);
        this.verificationCode = '';
      }
    }
  },
  async mounted() {
    if (!this.verificationResult.length) {
      this.$eventHub.$emit('setPhoneCountdown', this.resendSMSTimeDefaultValue);
    }
  },
  async created() {
    this.$eventHub.$on('setPhoneCountdown', num => {
      this.countdown = num;
    });
    if (this.isDynamicFormStep) {
      await this.setDialogHeaderType('navigation');
    } else {
      await this.setDialogHeaderType('information');
    }
  },
  destroyed() {
    this.$eventHub.$off('setPhoneCountdown');
  },
  methods: {
    ...mapActions({
      setDialogHeaderType: 'profile/phoneVerification/setDialogHeaderType'
    }),
    async resendSms() {
      this.loadingResend = true;
      await this.resendPhoneVerification();
      this.countdown = this.resendSMSTimeDefaultValue;
      this.verificationCode = '';
      this.phoneVerificationError = false;
      this.$eventHub.$emit('resetSegments');
      this.$nextTick(() => {
        this.$eventHub.$emit('resetPhoneVerificationValidation');
      });
      this.loadingResend = false;
    }
  }
};
</script>
